import React from "react";

import VacancyDataProvider from "../../../../providers/VacancyDataProvider";
import List from "./List";

export default function VacancyList({ name }) {
    return (
        <VacancyDataProvider>
            <List name={name} />
        </VacancyDataProvider>
    );
}
